import PropTypes from 'prop-types';
import { Box, Divider, Drawer, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LogoSection from '../LogoSection';
import CompanySection from '../companySection';
import { APP_VERSION } from '../../../version';
import MenuList from './MenuList';
import { drawerWidth } from 'store/constant';

function Sidebar({ desktop = true, drawerOpen, drawerToggle, window }) {
    const { t } = useTranslation('navigation', { useSuspense: false });
    const container = window !== undefined ? () => window.document.body : undefined;
    const closeAfterNavigation = (event) => {
        const link = event.target.closest?.('a[href]');
        // Expanding a submenu is a button click, so it keeps the drawer open.
        if (!desktop && link && link.target !== '_blank') drawerToggle();
    };
    return (
        <Box
            component="nav"
            aria-label={t('main', { defaultValue: 'Navegação principal' })}
            sx={{ width: desktop ? drawerWidth : 0, flexShrink: 0 }}
        >
            <Drawer
                id="medical-sidebar"
                container={container}
                variant={desktop ? 'permanent' : 'temporary'}
                anchor="left"
                open={desktop || drawerOpen}
                onClose={drawerToggle}
                ModalProps={{ keepMounted: true }}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        maxWidth: 'calc(100vw - 48px)',
                        height: '100dvh',
                        background: 'linear-gradient(180deg, #0A579B, #0091EA)',
                        color: '#fff',
                        borderRight: 'none',
                        overflow: 'hidden'
                    }
                }}
            >
                <Box
                    onClick={closeAfterNavigation}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        minHeight: 0
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            height: 80,
                            flexShrink: 0,
                            px: 2,
                            py: 2,
                            '& img, & svg': { maxWidth: '100%' }
                        }}
                    >
                        <LogoSection />
                    </Box>
                    <Divider
                        sx={{ borderColor: 'white', width: '100%', flexShrink: 0 }}
                    />
                    <Box
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            overscrollBehavior: 'contain'
                        }}
                    >
                        <MenuList />
                    </Box>
                    <Box
                        sx={{
                            mt: 'auto',
                            flexShrink: 0,
                            textAlign: 'center',
                            pt: 2,
                            pb: 2
                        }}
                    >
                        <Typography variant="body2" sx={{ color: 'white', mb: 1 }}>
                            POWERED BY
                        </Typography>
                        <CompanySection />
                        <Typography
                            variant="caption"
                            sx={{ display: 'block', color: 'white', opacity: 0.7, mt: 1 }}
                        >
                            v{APP_VERSION}
                        </Typography>
                    </Box>
                </Box>
            </Drawer>
        </Box>
    );
}
Sidebar.propTypes = {
    desktop: PropTypes.bool,
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};
export default Sidebar;
